export default __webpack_public_path__ + "static/media/vinay.cd8d912d.jpg";